import { defineMessages } from "react-intl";

const messages = defineMessages({
  date: {
    id: "Sort.date",
    defaultMessage: "Date",
  },
  distance: {
    id: "Sort.distance",
    defaultMessage: "Distance",
  },
  popularity: {
    id: "Sort.popularity",
    defaultMessage: "Popularity",
  },
  parkingpass: {
    id: "Sort.parkingpass",
    defaultMessage: "Parking pass",
  },
});

export default messages;
